import { render } from "./DepartureTo.vue?vue&type=template&id=6eb55fb9&scoped=true"
import script from "./DepartureTo.vue?vue&type=script&lang=js"
export * from "./DepartureTo.vue?vue&type=script&lang=js"

import "./DepartureTo.vue?vue&type=style&index=0&id=6eb55fb9&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb55fb9"]])

export default __exports__